import { trace, context, SpanStatusCode } from '@opentelemetry/api'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import {
  ConsoleInstrumentation,
  ErrorsInstrumentation,
  getWebInstrumentations,
  initializeFaro,
} from '@grafana/faro-web-sdk'
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from '@opentelemetry/semantic-conventions'
import { resourceFromAttributes } from '@opentelemetry/resources'
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web'
import { W3CTraceContextPropagator } from '@opentelemetry/core'
import { ZoneContextManager } from '@opentelemetry/context-zone-peer-dep'
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request'
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { LoggerProvider } from '@opentelemetry/sdk-logs'
import { ExceptionInstrumentation } from '@opentelemetry/instrumentation-web-exception'
import { UserInteractionInstrumentation } from '@opentelemetry/instrumentation-user-interaction'

import { environment } from '../environments/environment'

export function faroInitializer(): Function {
  return async () => {
    const collectorUrl = environment.telemetryUrl
    const ignoreUrls = [collectorUrl]
    const resources = resourceFromAttributes({
      [ATTR_SERVICE_NAME]: 'inscricao-publico',
      [ATTR_SERVICE_VERSION]: '2.2.21',
    })

    const faro = initializeFaro({
      url: collectorUrl,
      instrumentations: [
        ...getWebInstrumentations(),
        new ErrorsInstrumentation(),
        new TracingInstrumentation(),
        new ConsoleInstrumentation(),
      ],
      consoleInstrumentation: {
        consoleErrorAsLog: true,
      },
      app: {
        name: 'inscricao-privado',
        version: '2.3.25',
        environment: environment.envName,
      },
      experimental: {
        trackNavigation: true,
      },
      paused: !environment.enableTelemetry,
    })

    const provider = new WebTracerProvider({
      resource: resources,
    })

    provider.register({
      propagator: new W3CTraceContextPropagator(),
      contextManager: new ZoneContextManager(),
    })

    const baseUrl = environment.baseUrlApi

    // cria um regex que cobre toda a API
    const apiRegex = new RegExp(`^${baseUrl.replace(/\/$/, '')}(/|$)`)

    registerInstrumentations({
      loggerProvider: new LoggerProvider({
        resource: resources,
      }),
      instrumentations: [
        new DocumentLoadInstrumentation(),
        new XMLHttpRequestInstrumentation({
          ignoreUrls,
          propagateTraceHeaderCorsUrls: [apiRegex],
          applyCustomAttributesOnSpan: (span, xhr) => {
            if (!xhr.responseURL) {
              span.setStatus({ code: SpanStatusCode.ERROR })
              return
            }

            span.updateName(xhr.responseURL)

            if (xhr.status >= 400) {
              span.setStatus({ code: SpanStatusCode.ERROR })
            }
          },
        }),
        new UserInteractionInstrumentation({
          eventNames: ['paste', 'copy'],
        }),
        new ExceptionInstrumentation(),
      ],
    })

    faro.api.initOTEL(trace, context)
  }
}
